import React from "react";
import { Box, Paper, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

export default function AuthLayout({ children, showClose = true, sideImage }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: { xs: 3, md: 4 }
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "min(1100px, 100%)",
          overflow: "hidden",
          border: "1px solid",
          borderColor: "divider",
          boxShadow: (t) => t.shadows[10]
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            minHeight: { xs: "auto", md: 520 }
          }}
        >
          {/* Left */}
          <Box
            sx={{
              position: "relative",
              p: { xs: 3, md: 5 },
              bgcolor: "background.paper"
            }}
          >
            {showClose ? (
              <IconButton
                onClick={() => navigate("/")}
                sx={{ position: "absolute", top: 14, right: 14 }}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
            ) : null}

            {children}
          </Box>

          {/* Right image */}
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              backgroundImage: `url(${sideImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center"
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
}
